import { User, getAuth, updateProfile } from "firebase/auth";

import { createStore } from "./store.js";

let initialStateFirebaseUser = {
	user: {} as User
};

export namespace FirebaseUser {
	export const store = createStore({ initialState: initialStateFirebaseUser, id: "FirebaseUser" });
	let fn = async (state: Partial<typeof initialStateFirebaseUser>, newState: Partial<typeof initialStateFirebaseUser>) => {
		if (newState.user && newState.user.displayName && getAuth().currentUser?.displayName != newState.user.displayName) {
			debugger;
			updateProfile(getAuth().currentUser!, {
				displayName: newState.user.displayName
			});
		}
		if (newState.user && newState.user.photoURL && getAuth().currentUser?.photoURL != newState.user.photoURL) {
			debugger;
			updateProfile(getAuth().currentUser!, {
				photoURL: newState.user.photoURL
			});
		}
	};
	store.setOnPrePatch(fn);
	store.setOnPreSet(fn);
}
